import { parseContentfulFaqForAccordion } from 'src/common/parseContentfulFaqForAccordion'
import { getModifiedDate } from '../../../common/utils'
import { relatedPostsConverter } from '../../../common/richTextContentUtils'
import { BLOCKS } from '@contentful/rich-text-types'
import { toKebabCase, getElemFromContent } from '../../../common/helpers'
import { findKeyAndReplaceValue } from '../../../common/utils/findKeyAndReplaceValue'
import { replacePlaceholders } from '../../../common/utils/replacePlaceholders'

export function responseToBlogPostProps(Component) {
  // eslint-disable-next-line react/display-name
  return ({ page, recommendedReads = {}, ...props }) => {
    const body = props.content.content || []
    const keyTakeaways = props.keyTakeaways ?? ''
    const { videoUrl: videoUrlRaw } = props

    const videoUrl =
      videoUrlRaw?.content?.[0]?.content?.[0]?.value || videoUrlRaw

    const categoryBreadcrumbs =
      page?.category && page.path !== `${page.category.slug}/`
        ? {
            label: page?.category?.title,
            path: `/l/${page?.category?.slug}`,
          }
        : {
            label: 'Home',
            path: `/`,
          }

    const relatedPostsContent = relatedPostsConverter(
      body,
      recommendedReads.top
    )

    const h2List = getElemFromContent(body, BLOCKS.HEADING_2)

    const componentProps = {
      ...props,
      dataStrip: [
        findKeyAndReplaceValue(props.dataStrip?.intro?.content, (value) =>
          replacePlaceholders({
            text: value,
            data: props.dataStripVariablesJson?.data,
          })
        ),
        findKeyAndReplaceValue(props.dataStrip?.middle?.content, (value) =>
          replacePlaceholders({
            text: value,
            data: props.dataStripVariablesJson?.data,
          })
        ),
        findKeyAndReplaceValue(props.dataStrip?.next?.content, (value) =>
          replacePlaceholders({
            text: value,
            data: props.dataStripVariablesJson?.data,
          })
        ),
        findKeyAndReplaceValue(props.dataStrip?.ending?.content, (value) =>
          replacePlaceholders({
            text: value,
            data: props.dataStripVariablesJson?.data,
          })
        ),
      ].filter((item) => item),
      dataStripSource: findKeyAndReplaceValue(
        props.dataStrip?.source?.content,
        (value) =>
          replacePlaceholders({
            text: value,
            data: props.dataStripVariablesJson?.data,
          })
      ),
      pageSlug: page.path,
      recommendedReads: recommendedReads.bottom || [],
      content: {
        data: {},
        content: relatedPostsContent,
        nodeType: 'document',
      },
      keyTakeaways: keyTakeaways.length
        ? keyTakeaways.split('\n').filter((item) => item.length)
        : [],
      faq: parseContentfulFaqForAccordion(props?.faq),
      author: {
        fullName: props?.author?.fullName,

        url: `/author/${props?.author?.slug}`,
        description: props?.author?.description,
        image: props.author?.avatar,
      },
      ...(props.reviewedBy
        ? {
            reviewer: {
              fullName: props.reviewedBy.fullName,

              url: `/author/${props.reviewedBy.slug}`,
              description: props.reviewedBy?.description,
              image: props.reviewedBy?.avatar,
            },
          }
        : {}),

      breadcrumbs: [
        { ...categoryBreadcrumbs },
        { label: props.title, path: page.path },
      ],
      modifiedDate: getModifiedDate(page.updatedAt, props.customPublishedDate),
      image: {
        path: props.imageAsset.url,

        label: props.imageAsset.title,
      },
      tableOfContent:
        h2List.length >= 4
          ? h2List.map((item) => {
              const value = item.content[0]?.value || ''

              return { value, href: `#${toKebabCase(value)}` }
            })
          : [],
      videoUrl: videoUrl || props.videoUrl,
    }

    return <Component {...componentProps} />
  }
}
